import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalibrationRequestToExitService {

  constructor(private http: HttpClient) { }


  SubmitRequestToExit(Token: String,
    id:number,
    dsc:string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/SubmitRequestToExit?token=" + Token
      + "&id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetRequestToExitDetail(Token: String,id:number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetRequestToExitDetail?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

}
